import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaStar } from 'react-icons/fa';
import { fetchApi } from '../../utlis/axios';
import { addToast } from '../../Redux/Slices/toast-slice';

const emojiMap = {
  1: { icon: '😭', label: 'Very Dissatisfied' },
  2: { icon: '☹️', label: 'Dissatisfied' },
  3: { icon: '😐', label: 'Neutral' },
  4: { icon: '🙂', label: 'Satisfied' },
  5: { icon: '😄', label: 'Very Satisfied' },
};

const FeedbackComponent = ({ isOpen, setIsOpen }) => {
  const { theme } = useSelector((state) => state.theme);
  const { userInfo } = useSelector((state) => state?.auth || {});
  const dispatch = useDispatch();
  const [star, setStar] = useState(3);
  const [comment, setComment] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [showAddMore, setShowAddMore] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [fileUploading, setFileUploading] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    setFileUploading(true)
    try {
      const response = await fetchApi.post('attachments/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userInfo?.access_token}`,
        },
      });

      const attachmentId = response.data?.id;
      if (attachmentId) {
        setAttachments((prev) => [...prev, attachmentId]);
        setShowAddMore(true);
      }
    } catch (error) {
      console.error('Attachment upload failed', error.response?.data || error);
      dispatch(addToast({ message: 'Failed to upload file. Make sure you are uploading a valid file.', type: 'error' }));
    } finally {
      setFileUploading(false)
    }
  };

  const handleSubmit = async () => {
    const feedback = {
      comment,
      star,
      created_by: userInfo?.user?.id,
      attachment: attachments,
    };
    if (fileUploading) {
      dispatch(addToast({ message: 'Please wait while the file is uploading.', type: 'warn' }));
      return
    }
    setSubmitting(true)
    try {
      const res = await fetchApi.post('feedback/', feedback, {
        headers: {
          Authorization: `Bearer ${userInfo?.access_token}`,
        },
      });
      if (res.status === 201) {
        dispatch(addToast({ message: 'Feedback submitted successfully.', type: 'success' }));
        setIsOpen(false)
        setStar(1);
        setComment('');
        setAttachments([]);
        setShowAddMore(false);
      }

    } catch (error) {
      console.error('Feedback submission failed', error.response?.data || error);
      dispatch(addToast({ message: 'Failed to submit feedback. Please try again.', type: 'error' }));
    } finally {
      setSubmitting(false)
    }
  };

  const themeClasses =
    theme === 'dark'
      ? 'bg-gray-800 text-white border-gray-700'
      : 'bg-white text-black border-gray-200';

  return (
    <div className={` max-w-sm mx-auto p-6 rounded-xl border shadow-xl fixed bottom-24 z-[1000] left-8 fontPoppins ${theme === 'dark' ? 'bg-[#1C1C1E] text-white border-[#556557]' : 'bg-white text-black'}`}>
      <h2 className="text-xl font-bold mb-2">How was your experience?</h2>
      <p className={`mb-4 text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
        Your feedback helps us build a better experience
      </p>

      <div className="flex flex-col items-center mb-4">
        <div className="text-5xl">{emojiMap[star].icon}</div>
        <p className="mt-2 font-semibold">{emojiMap[star].label}</p>
      </div>

      <div className="flex justify-center mb-4">
        {[1, 2, 3, 4, 5].map((num) => (
          <button key={num} onClick={() => setStar(num)} className={`${star >= num ? 'text-yellow-400' : 'text-gray-500'}`}>
            <FaStar className={`mx-1 ${star >= num ? '' : 'opacity-30'}`} size={24} />
          </button>
        ))}
      </div>

      <textarea
        className={`w-full p-2 border mb-4 rounded-[10px] bg-transparent ${theme === "dark"
          ? "text-white border-gray-400"
          : "text-black border-gray-600"
          }`}
        rows={4}
        placeholder="Tell us what you liked or what we could improve..."
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />

      <label htmlFor="" className='flex items-center'>Attachments <span className='tex-red-600'>*</span></label>
      <div className="mb-4">
        <input type="file" onChange={handleFileUpload} className={`block w-full bg-transparent p-2 text-sm border  rounded-[10px] ${theme === "dark"
          ? "text-white border-gray-400"
          : "text-black border-gray-600"
          }`} />
        {showAddMore && (
          <button
            onClick={() => document.querySelector('input[type=file]').click()}
            className="mt-2 text-sm text-red-500 underline"
          >
            Add More +
          </button>
        )}
      </div>

      <button onClick={handleSubmit} className="w-full py-2 heroButton" disabled={submitting}>
        {submitting ? 'Submitting...' : 'Submit Feedback'}
      </button>
    </div>
  );
};

export default FeedbackComponent;
